// extracted by mini-css-extract-plugin
module.exports = {"specItem":"styles__specItem--2TBYm","compact":"styles__compact--2Aqlw","padded":"styles__padded--J8Hu7","label":"styles__label--1u_rG","value":"styles__value--25Lx5"};